export default __webpack_public_path__ + "static/logo-7576adec632730172f9d3680494c00ed.svg";